// #445: after #441 widened the airport list, long names (e.g. "Birmingham-
// Shuttlesworth International Airport") overflowed the picker's "Your pickup
// airport" field. This is the shared DISPLAY abbreviation for the selected-
// airport label in the picker button, used by signup + checkout + admin so the
// shortening is congruent. It shortens "International Airport" -> "Intl" to save
// width; the CSS truncate on the field is the hard guarantee against overflow.
// The FULL name stays in the dropdown options + the stored value - this only
// affects the collapsed button label.
export function abbreviateAirportName(name: string): string {
  return name
    .replace(/\bInternational Airport\b/gi, "Intl")
    .replace(/\bInternational\b/gi, "Intl")
    .replace(/\s{2,}/g, " ")
    .trim();
}
